import { render } from "./Configuraciones.vue?vue&type=template&id=7b481440&scoped=true"
import script from "./Configuraciones.vue?vue&type=script&lang=js"
export * from "./Configuraciones.vue?vue&type=script&lang=js"

import "./Configuraciones.vue?vue&type=style&index=0&id=7b481440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b481440"]])

export default __exports__